export const isOk = (statusCode) => statusCode === 200;
